/**
 * Cognito Hosted UI entry points for the default app client.
 *
 * SSO users never come through here: they re-enter via /sso/:clientName so the
 * authorize call carries `identity_provider` and federates straight to their
 * own IdP.
 */
const buildHostedUiUrl = (path: 'login' | 'signup'): string => {
  const authUri = process.env.REACT_APP_COGNITO_AUTH_URI
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID
  const redirectUri = `${process.env.REACT_APP_COGNITO_REDIRECT_URI}/${clientId}`
  const base = `${authUri}/${path}?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}`
  // Second line of defence behind the Cognito /logout hop in useLogout: if a
  // session cookie survives anyway, `prompt=login` makes Cognito authenticate
  // the user again rather than showing the "You're still signed in" page and
  // silently reusing the previous account. Managed login branding only -- the
  // classic Hosted UI ignores it. Sign-up never has a session to reuse.
  return path === 'login' ? `${base}&prompt=login` : base
}

export const cognitoLoginUrl = (): string => buildHostedUiUrl('login')

export const cognitoSignUpUrl = (): string => buildHostedUiUrl('signup')
